export { default as getDecimalsFromRating } from './get-decimals-from-rating';
